export const API_URL = process.env.VUE_APP_API_URL;
export const FACILITY_BOOKING_API_URL = process.env.VUE_APP_FACILITY_BOOKING_API_URL;
export const languages = [
  {
    title: 'ไทย',
    langCode: 'th',
    request: {
      language: 'th, en;q=0.9, *;q=0.3',
    },
  },
  {
    title: 'English',
    langCode: 'en',
    request: {
      language: 'en, th;q=0.9, *;q=0.3',
    },
  },
  // {
  //   title: 'Japanese',
  //   langCode: 'ja',
  //   request: {
  //     language: 'ja, en;q=0.9, *;q=0.3',
  //   },
  // },
  // {
  //   title: 'Chinese Simplified',
  //   langCode: 'zh-Hans',
  //   request: {
  //     language: 'zh-Hans, en;q=0.9, *;q=0.3',
  //   },
  // },
  // {
  //   title: 'Chinese Traditional',
  //   langCode: 'zh-Hant',
  //   request: {
  //     language: 'zh-Hant, en;q=0.9, *;q=0.3',
  //   },
  // },
];

export const languageTitle = (langCode) => {
  let title = '';
  languages.forEach((language) => {
    let lang = langCode;
    // handle old langCode format
    if (langCode === 'zh') lang = 'zh-Hans';

    if (language.langCode === lang) {
      title = language.title;
    }
  });
  return title || 'Unknown';
};

export const Announcement = {
  PROJECT: 'project',
  CENTRAL: 'central',
  FAMILY: 'family',
};

export const announcementType = [
  {
    title: 'โครงการ',
    type: 'project',
  },
  {
    title: 'Lifestyle',
    type: 'central',
  },
  {
    title: 'ข่าวสารและอัพเดต',
    type: 'family',
  },
];

export const popupType = [
  { title: 'ไม่ต้องทำอะไร', type: 'NOTHING' },
  { title: 'เปิดหน้า', type: 'EXTERNAL_BROWSER' },
  { title: 'เปิดหน้าแอพ', type: 'PAGE_IN_APP' },
];

export const AppointmentTimeSlots = [
  {
    timeSlot: '09:00:00',
    display: '09:00 - 12:00',
    maxTimeSlot: '12:00:00'
  },
  {
    timeSlot: '13:00:00',
    display: '13:00 - 16:00',
    maxTimeSlot: '16:00:00'
  },
];

export const BookingStatuses = [
  {
    "objectId": "d584265c-dab9-47f1-ad16-0fff21dda6d4",
    "code": "CONFIRM",
    "display": "ยืนยันรับงาน",
    "color": "#B4891A",
    "bgColor": "#FFF9E9",
  },
  {
    "objectId": "1373a4b6-a21f-40dc-b5f3-7c83cc6c5bb8",
    "code": "CANCELED",
    "display": "ยกเลิก",
    "color": "#E83256",
    "bgColor": "#FDEBEE",
  },
  {
    "objectId": "f48fee0a-5ab2-44b6-9a42-a23ebb885f12",
    "code": "COMPLETED",
    "display": "เสร็จสิ้น",
    "color": "#3C6B0E",
    "bgColor": "#F4FFE9",
  },
  {
    "objectId": "da7dd784-b519-4c4a-95d0-a9998cb4b5bb",
    "code": "IN-PROGRESS",
    "display": "กำลังดำเนินงาน",
    "color": "#B4891A",
    "bgColor": "#FFF9E9",
  },
  {
    "objectId": "169ef6bc-7fd7-442a-a4b7-abb7d721ba1c",
    "code": "NOT_REVIEW",
    "display": "รอให้คะแนน",
    "color": "#7F92A3",
    "bgColor": "#F7FAFC",
  },
  {
    "objectId": "176f6e6a-dc6f-4a5b-bf82-ca46c1b3d1cb",
    "code": "PENDING",
    "display": "รอติดต่อกลับ",
    "color": "#B4891A",
    "bgColor": "#FFF9E9",
  },
  {
    "objectId": "b7bb7760-ad00-4a6a-8a05-5546abcb1f3d",
    "code": "PENDING_PAYMENT",
    "display": "รอชำระเงิน",
    "color": "#B4891A",
    "bgColor": "#FFF9E9",
  }
];

export const CancelBookingId = '2B0CF790-B46B-49AA-B2F9-40783546EA30';

export const ErrorStatusList = [
  {
    code: 'UNAUTHORIZED',
    display: 'คุณไม่มีสิทธิในการเข้าถึงเว็บไซต​์'
  },
  {
    code: 'EXPIRED',
    display: 'Link ของคุณหมดอายุแล้ว กรุณาเข้าสู่ระบบด้วยอีเมลฉบับใหม่'
  },
];
